<template>
    <header class="wc-kit__active-header">
        <h1>Kit Builder</h1>
        <div>
            <h2 class="kit-subtitle">1. Choose your kit type</h2>
        </div>
    </header>
    <ul class="kit-list">

        <li v-for="(list, key) in $store.state.lists" 
            class="kit-list__item"
            :class="{ active: list.id === $store.state.kitId }"
            :key="key"
            @click="$store.commit('setKitId', list.id)">
            <figure>
                <img :src="list.thumbnail" :alt="list.title">
            </figure>
            <div>
                <h3 v-html="list.title"></h3>
                <label class="kit-list__item-check">
                    <i class="fas fa-check"></i>
                </label>
            </div>
        </li>

    </ul>
</template>

<style lang="scss">
    .kit-list {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 15px;

        @media (max-width: 1024px) {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }

        @media (max-width: 576px) {
            grid-template-columns: 1fr;
        }

        &__item {
            border-radius: 3px;
            border: 1.5px solid #E5E7EC;
            background: #FFF;
            padding: 10px;
            transition: border-color .3s cubic-bezier(0.075, 0.82, 0.165, 1);
            cursor: pointer;

            &:hover {
                border-color: #F97623;
            }

            &.active {
                border-color: #F97623;
            }

            &.active & {
                &-check {
                    border-color: #F97623;
                    background-color: #F97623;
                }
            }

            figure {
                border-radius: 3.486px 3.486px 0px 0px;
                overflow: hidden;
                height: 157px;
                position: relative;

                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            div {
                padding-top: 10px;
                display: flex;
                justify-content: space-between;
                gap: 10px;
            }

            &-check {
                border: 1px solid #E5E7EC;
                height: 22px;
                width: 22px;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 10px;
                color: #fff;
                transition: all .3s cubic-bezier(0.075, 0.82, 0.165, 1);
            }
        }
    }
</style>